import { apiSlice } from "../stores/base/api-slice";
import { RecommendationDetails } from "./contract/solar-recommendation";

const solarRecommendationEndpoints = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getSolarRecommendation: builder.query<RecommendationDetails, void>({
      query: () => ({
        url: "/solar-recommendation/customer",
        method: "GET",
      }),
    }),
    rejectSolarRecommendationOffer: builder.mutation<void, string>({
      query: (recommendationId) => ({
        url: "/product/solar-recommendation/reject",
        method: "POST",
        body: { recommendationId: recommendationId },
      }),
    }),
  }),
});

export const { useLazyGetSolarRecommendationQuery, useRejectSolarRecommendationOfferMutation } = solarRecommendationEndpoints;
